import { Component, OnInit, Input } from '@angular/core';
import { Ranking, RankingsService } from 'src/app/services/rankings.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: '[app-ranking-row]',
  templateUrl: './ranking-row.component.html',
  styleUrls: ['./ranking-row.component.scss']
})
export class RankingRowComponent implements OnInit {

  @Input() ranking : Ranking;

  constructor(
    public rankingsService: RankingsService,
    private toastr: ToastrService,
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal
  ) {
    modalConfig.backdrop = 'static';}

  ngOnInit() {
  }
  open(content) {
    this.modalService.open(content);
  }
  deleteDraftRanking() {
    //this.toastr.warning("Delete placeholder - to be developed...\n\nThis would delete ranking " + this.ranking.rankingName);
    this.rankingsService.deleteRanking(this.ranking.rankingId);
  }

}
